module.exports = __webpack_public_path__ + "images/Youtube.2dc92f1d75896225054a0e9ec3d0cfe2.png";